import React, { useEffect } from 'react';
import refreshDeviceToken from './lib/refreshDeviceToken';

export default function AuthProvider({ children }) {
  useEffect(() => {
    const handler = async (ev) => {
      console.log('[TruvaSentinel] Native-triggered token refresh initiated');
      try {
        const authToken = sessionStorage.getItem('authToken') || '';
        const device = window.truvaDevice || null;
        await refreshDeviceToken(authToken, device);
        console.log('[TruvaSentinel] Native-triggered token refresh completed');
      } catch (e) {
        console.warn('[TruvaSentinel] Native-triggered refresh failed', e);
      }
    };
    window.addEventListener('truvaRefreshSession', handler);
    return () => window.removeEventListener('truvaRefreshSession', handler);
  }, []);

  return children || null;
}
